<div class="p-4">
  <button pButton type="button" label="Voltar" icon="pi pi-arrow-left" (click)="voltar()"></button>

  <div *ngIf="assinatura" class="p-4 mt-4 card">
    <h3>Assinatura #{{assinatura.empresaId || assinatura.id}} - {{assinatura.nomeEmpresa || assinatura.empresaId}}</h3>
    <div class="grid">
      <div class="col-6">
        <div><strong>Plano:</strong> {{assinatura.planoAssinatura || '-'}}</div>
        <div><strong>Status:</strong> {{assinatura.statusAssinatura || '-'}}</div>
        <div><strong>Data Início:</strong> {{assinatura.dataAquisicao | date:'dd/MM/yyyy'}}</div>
      </div>
      <div class="col-6">
        <div><strong>Data Fim:</strong> {{assinatura.dataVencimento | date:'dd/MM/yyyy'}}</div>
        <div><strong>Dias Restantes:</strong> {{assinatura.diasRestantes ?? '-'}}</div>
        <div><strong>Bloqueado:</strong> {{assinatura.bloqueadoPorAssinatura ? 'Sim' : 'Não'}}</div>
      </div>
    </div>
    <div class="mt-4">
      <button pButton type="button" label="Editar" icon="pi pi-pencil" (click)="editar()"></button>
    </div>
  </div>
</div>
